module.exports = __webpack_public_path__ + "static/story5-02-533x800-eface0e6c92c5f7c7ea4e594e033f365.jpg";